import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import QuoteModal from '../ModalOrcamento';
import { 
  Target,
  Eye,
  Heart,
  Award,
  Users,
  Zap,
  Shield,
  TrendingUp,
  CheckCircle2,
  Lightbulb,
  Building2,
  MapPin,
  Phone,
  Mail,
  Globe,
  Code,
  Server,
  Network,
  Wrench,
  BookOpen,
  Briefcase
} from 'lucide-react';
import Header from "../Header";
import Footer from "../Footer";

export default function AboutPage({ isDarkMode, setIsDarkMode }) {
  const navigate = useNavigate();
    const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);
const [preSelectedService, setPreSelectedService] = useState(null);
  const [activeTab, setActiveTab] = useState('mission');

  useEffect(() => {
    document.title = "Sobre";
  
  });





  const values = [
    {
      icon: Shield,
      title: "Compromisso",
      description: "Actuamos com responsabilidade e dedicação em cada projecto.",
      color: "from-blue-500 to-cyan-500"
    },
    {
      icon: Zap,
      title: "Inovação",
      description: "Buscamos constantemente novas soluções tecnológicas para responder às necessidades do mercado.",
      color: "from-cyan-500 to-blue-600"
    },
    {
      icon: CheckCircle2,
      title: "Ética e Transparência",
      description: "Trabalhamos com integridade e respeito às normas legais.",
      color: "from-blue-600 to-purple-600"
    },
    {
      icon: Award,
      title: "Qualidade",
      description: "Garantimos excelência técnica nos nossos produtos e serviços.",
      color: "from-purple-600 to-violet-600"
    },
    {
      icon: Heart,
      title: "Responsabilidade Social",
      description: "Desenvolvemos projectos que contribuem para o crescimento social e tecnológico da comunidade.",
      color: "from-violet-600 to-pink-600"
    },
    {
      icon: Users,
      title: "Profissionalismo",
      description: "Mantemos padrões elevados de atendimento e execução.",
      color: "from-pink-600 to-blue-500"
    }
  ];

  const stats = [
    { number: "20+", label: "Projectos Concluídos", icon: Award },
    { number: "95%", label: "Taxa de Satisfação", icon: Briefcase },
    { number: "200+", label: "Clientes Satisfeitos", icon: Users },
    { number: "24/7", label: "Suporte Técnico", icon: Shield }
  ];

  const timeline = [
    {
      year: "2023",
      title: "Fundação",
      description: "Início das operações"
    },
    {
      year: "2023",
      title: "Certificação AGT",
      description: "Autorização para comercializar software certificado"
    },
    {
      year: "2019",
      title: "Expansão de Serviços",
      description: "Implementação de cabeamento estruturado e consultoria"
    },
    {
      year: "2021",
      title: "Projectos Sociais",
      description: "Lançamento de iniciativas de inclusão digital"
    },
    {
      year: "2024",
      title: "Reconhecimento Nacional",
      description: "Consolidação como referência em soluções tecnológicas"
    }
  ];

  return (
    <div className={`min-h-screen transition-colors duration-300 ${
      isDarkMode ? 'bg-gray-900 text-white' : 'bg-white text-gray-900'
    }`}>
      {/* Animated Background Particles */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none">
        <div className={`absolute top-0 right-0 w-[800px] h-[800px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-blue-500/10' : 'bg-blue-400/20'
        }`}></div>
        <div className={`absolute bottom-0 left-0 w-[600px] h-[600px] rounded-full blur-[120px] animate-pulse ${
          isDarkMode ? 'bg-purple-500/10' : 'bg-purple-500/20'
        }`} style={{animationDelay: '1s'}}></div>
        <div className={`absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] rounded-full blur-[100px] animate-pulse ${
          isDarkMode ? 'bg-cyan-500/5' : 'bg-cyan-400/15'
        }`} style={{animationDelay: '2s'}}></div>
        
        {/* Floating particles */}
        <div className="absolute top-[20%] left-[15%] w-1 h-1 bg-blue-500 rounded-full animate-float"></div>
        <div className="absolute top-[40%] right-[20%] w-1.5 h-1.5 bg-cyan-500 rounded-full animate-float" style={{animationDelay: '1s'}}></div>
        <div className="absolute top-[60%] left-[30%] w-1 h-1 bg-purple-500 rounded-full animate-float" style={{animationDelay: '2s'}}></div>
        <div className="absolute top-[80%] right-[40%] w-2 h-2 bg-blue-400 rounded-full animate-float" style={{animationDelay: '0.5s'}}></div>
        <div className="absolute top-[30%] right-[10%] w-1 h-1 bg-cyan-400 rounded-full animate-float" style={{animationDelay: '1.5s'}}></div>
        <div className="absolute top-[70%] left-[50%] w-1.5 h-1.5 bg-purple-400 rounded-full animate-float" style={{animationDelay: '2.5s'}}></div>
      </div>

      <Header isDarkMode={isDarkMode} setIsDarkMode={setIsDarkMode} />

      {/* Hero Section */}
      <section className={`relative pt-32 pb-20 px-6 overflow-hidden ${
        isDarkMode ? 'bg-gray-800' : 'bg-gradient-to-br from-blue-50 to-purple-50'
      }`}>
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center space-x-2 px-4 py-2 bg-blue-500/10 border border-blue-500/30 rounded-full mb-6">
              <Building2 size={20} className="text-blue-600" />
              <span className={`text-sm font-semibold ${
                isDarkMode ? 'text-cyan-400' : 'text-blue-600'
              }`}>
                Desde 2015
              </span>
            </div>

            <h1 className={`text-4xl md:text-6xl font-bold mb-6 ${
              isDarkMode ? 'text-white' : 'text-gray-900'
            }`}>
              Sobre a <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">AngoNet</span>
            </h1>
            
            <p className={`text-xl md:text-2xl mb-8 leading-relaxed ${
              isDarkMode ? 'text-gray-400' : 'text-gray-600'
            }`}>
              Empresa angolana de tecnologia e soluções digitais, comprometida com a inovação, 
              qualidade técnica e desenvolvimento social em Angola.
            </p>

            <div className="flex flex-wrap items-center justify-center gap-4 text-sm">
              <div className="flex items-center space-x-2">
                <MapPin size={18} className={isDarkMode ? 'text-cyan-400' : 'text-blue-600'} />
                <span className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                  Luanda, Município de Viana
                </span>
              </div>
              <div className={`w-1 h-1 rounded-full ${isDarkMode ? 'bg-gray-600' : 'bg-gray-400'}`}></div>
            
            </div>
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className={`relative py-16 px-6 border-y ${
        isDarkMode 
          ? 'bg-gradient-to-br from-blue-950/30 to-purple-950/30 border-white/10'
          : 'bg-gradient-to-br from-blue-50 to-purple-50 border-gray-200'
      }`}>
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-8">
            {stats.map((stat, index) => {
              const Icon = stat.icon;
              return (
                <div key={index} className="text-center">
                  <div className="inline-flex p-4 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl mb-4">
                    <Icon size={32} className="text-white" />
                  </div>
                  <div className="text-4xl md:text-5xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-2">
                    {stat.number}
                  </div>
                  <div className={`text-sm md:text-base font-medium ${
                    isDarkMode ? 'text-gray-400' : 'text-gray-700'
                  }`}>
                    {stat.label}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* About Content */}
      <section className="py-20 px-6 relative z-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
            <div>
              <h2 className={`text-3xl md:text-4xl font-bold mb-6 ${
                isDarkMode ? 'text-white' : 'text-gray-900'
              }`}>
                Quem <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Somos</span>
              </h2>
              <div className={`space-y-4 text-lg leading-relaxed ${
                isDarkMode ? 'text-gray-400' : 'text-gray-600'
              }`}>
                <p>
                  A <strong className={isDarkMode ? 'text-white' : 'text-gray-900'}>AngoNet</strong> é uma empresa angolana de tecnologia e soluções digitais, sediada em Luanda, Município de Viana, que actua no desenvolvimento de software, prestação de serviços informáticos e consultoria tecnológica.
                </p>
                <p>
                  Especializada na comercialização de <strong className={isDarkMode ? 'text-cyan-400' : 'text-blue-600'}>software certificado pela AGT</strong>, a AngoNet desenvolve também softwares personalizados, sistemas de facturação, soluções para restaurantes, além da criação de websites, e-mails profissionais e serviços de hospedagem e registo de domínio.
                </p>
                <p>
                  A AngoNet distingue-se pelo seu compromisso com a <strong className={isDarkMode ? 'text-cyan-400' : 'text-blue-600'}>inovação, legalidade, qualidade técnica e contribuição social</strong>, mantendo em carteira projectos sociais voltados para o desenvolvimento tecnológico e inclusão digital em Angola.
                </p>
              </div>
            </div>

            <div className="relative">
              <div className={`aspect-square rounded-2xl border backdrop-blur-sm flex items-center justify-center shadow-xl ${
                isDarkMode
                  ? 'bg-gradient-to-br from-blue-500/20 to-purple-500/20 border-white/10'
                  : 'bg-gradient-to-br from-blue-100 to-purple-100 border-gray-200'
              }`}>
                <div className="text-center p-8">
                  <Building2 size={120} className={`mx-auto mb-6 ${isDarkMode ? 'text-cyan-400' : 'text-blue-600'}`} />
                  <h3 className={`text-2xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                    Tecnologia Angolana
                  </h3>
                  <p className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                    Soluções desenvolvidas em Angola, para Angola
                  </p>
                </div>
              </div>
              {/* Decorative glows */}
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-blue-400/30 rounded-full blur-2xl"></div>
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-purple-400/30 rounded-full blur-2xl"></div>
            </div>
          </div>
        </div>
      </section>

      {/* Vision, Mission, Values Tabs */}
      <section className={`py-20 px-6 ${
        isDarkMode ? 'bg-gray-800' : 'bg-gradient-to-br from-blue-50 to-purple-50'
      }`}>
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className={`text-3xl md:text-5xl font-bold mb-4 ${
              isDarkMode ? 'text-white' : 'text-gray-900'
            }`}>
              Visão, Missão e <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">Valores</span>
            </h2>
          </div>

          {/* Tabs */}
          <div className="flex flex-wrap justify-center gap-4 mb-12">
            <button
              onClick={() => setActiveTab('vision')}
              className={`flex items-center space-x-2 px-8 py-4 rounded-full font-semibold transition-all ${
                activeTab === 'vision'
                  ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-xl scale-105'
                  : isDarkMode
                  ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                  : 'bg-white text-gray-700 hover:bg-gray-100 shadow-lg'
              }`}
            >
              <Eye size={20} />
              <span>Visão</span>
            </button>

            <button
              onClick={() => setActiveTab('mission')}
              className={`flex items-center space-x-2 px-8 py-4 rounded-full font-semibold transition-all ${
                activeTab === 'mission'
                  ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-xl scale-105'
                  : isDarkMode
                  ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                  : 'bg-white text-gray-700 hover:bg-gray-100 shadow-lg'
              }`}
            >
              <Target size={20} />
              <span>Missão</span>
            </button>

            <button
              onClick={() => setActiveTab('values')}
              className={`flex items-center space-x-2 px-8 py-4 rounded-full font-semibold transition-all ${
                activeTab === 'values'
                  ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-xl scale-105'
                  : isDarkMode
                  ? 'bg-gray-700 text-gray-300 hover:bg-gray-600'
                  : 'bg-white text-gray-700 hover:bg-gray-100 shadow-lg'
              }`}
            >
              <Heart size={20} />
              <span>Valores</span>
            </button>
          </div>

          {/* Tab Content */}
          <div className="max-w-5xl mx-auto">
            {activeTab === 'vision' && (
              <div className={`p-8 md:p-12 rounded-2xl ${
                isDarkMode ? 'bg-gray-900 border border-white/10' : 'bg-white border border-gray-200 shadow-xl'
              }`}>
                <div className="flex items-start space-x-4 mb-6">
                  <div className="flex-shrink-0 p-4 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl">
                    <Eye size={32} className="text-white" />
                  </div>
                  <div>
                    <h3 className={`text-2xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                      Nossa Visão
                    </h3>
                    <p className={`text-lg leading-relaxed ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                      Ser uma empresa de referência nacional em soluções tecnológicas, reconhecida pela inovação, 
                      qualidade dos seus serviços e impacto positivo no desenvolvimento digital e social de Angola.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'mission' && (
              <div className={`p-8 md:p-12 rounded-2xl ${
                isDarkMode ? 'bg-gray-900 border border-white/10' : 'bg-white border border-gray-200 shadow-xl'
              }`}>
                <div className="flex items-start space-x-4 mb-6">
                  <div className="flex-shrink-0 p-4 bg-gradient-to-r from-blue-600 to-purple-600 rounded-xl">
                    <Target size={32} className="text-white" />
                  </div>
                  <div>
                    <h3 className={`text-2xl font-bold mb-4 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                      Nossa Missão
                    </h3>
                    <p className={`text-lg leading-relaxed ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                      Desenvolver e implementar soluções tecnológicas eficientes, seguras e certificadas, 
                      que apoiem empresas e instituições no seu crescimento sustentável, promovendo simultaneamente 
                      a inclusão digital e o progresso social.
                    </p>
                  </div>
                </div>
              </div>
            )}

            {activeTab === 'values' && (
              <div className="grid md:grid-cols-2 gap-6">
                {values.map((value, index) => {
                  const Icon = value.icon;
                  return (
                    <div
                      key={index}
                      className={`p-6 rounded-2xl transition-all duration-300 ${
                        isDarkMode
                          ? 'bg-gray-900 border border-white/10 hover:border-cyan-500/50'
                          : 'bg-white border border-gray-200 hover:border-blue-500/50 shadow-lg hover:shadow-xl'
                      }`}
                    >
                      <div className={`inline-flex p-3 bg-gradient-to-r ${value.color} rounded-xl mb-4`}>
                        <Icon size={24} className="text-white" />
                      </div>
                      <h4 className={`text-xl font-bold mb-3 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                        {value.title}
                      </h4>
                      <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                        {value.description}
                      </p>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </section>

 

      {/* Timeline
      <section className={`py-20 px-6 ${
        isDarkMode ? 'bg-gray-800' : 'bg-gradient-to-br from-blue-50 to-purple-50'
      }`}>
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-16">
            <h2 className={`text-3xl md:text-5xl font-bold mb-4 ${
              isDarkMode ? 'text-white' : 'text-gray-900'
            }`}>
              Nossa <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">História</span>
            </h2>
          </div>

          <div className="relative">
           
            <div className={`absolute left-8 md:left-1/2 top-0 bottom-0 w-0.5 ${
              isDarkMode ? 'bg-gray-700' : 'bg-gray-300'
            }`}></div>

            {timeline.map((item, index) => (
              <div key={index} className="relative mb-12 last:mb-0">
                <div className={`flex items-center ${
                  index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                }`}>
                 
                  <div className={`w-full md:w-5/12 ${
                    index % 2 === 0 ? 'md:pr-12' : 'md:pl-12'
                  }`}>
                    <div className={`p-6 rounded-xl ${
                      isDarkMode ? 'bg-gray-900 border border-white/10' : 'bg-white border border-gray-200 shadow-lg'
                    }`}>
                      <div className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-2">
                        {item.year}
                      </div>
                      <h3 className={`text-xl font-bold mb-2 ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                        {item.title}
                      </h3>
                      <p className={`text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                        {item.description}
                      </p>
                    </div>
                  </div>

               
                  <div className="absolute left-8 md:left-1/2 transform md:-translate-x-1/2 w-4 h-4 bg-gradient-to-r from-blue-600 to-purple-600 rounded-full border-4 border-white dark:border-gray-900"></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section> */}

      {/* CTA Section */}
      <section className="py-20 px-6 relative z-10">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className={`text-3xl md:text-5xl font-bold mb-6 ${
            isDarkMode ? 'text-white' : 'text-gray-900'
          }`}>
            Pronto para Inovar?
          </h2>
          <p className={`text-xl mb-8 ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
            Entre em contacto connosco e descubra como podemos transformar o seu negócio
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button 
               onClick={() => setIsQuoteModalOpen(true)}
            className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full font-semibold hover:shadow-2xl hover:shadow-blue-500/50 transition-all">
              Solicitar Orçamento
            </button>
            <button 
             onClick={() => navigate('/projectos')}

            className={`px-8 py-4 border-2 rounded-full font-semibold transition-all ${
              isDarkMode
                ? 'border-white/20 text-white hover:bg-white/5'
                : 'border-gray-300 text-gray-700 hover:bg-white hover:border-blue-500'
            }`}>
              Ver Projectos
            </button>
          </div>
        </div>
      </section>

      <Footer isDarkMode={isDarkMode} />

      <style jsx>{`
        @keyframes float {
          0%, 100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-20px);
          }
        }

        .animate-float {
          animation: float 3s ease-in-out infinite;
        }
      `}</style>

              <QuoteModal
        isOpen={isQuoteModalOpen}
        onClose={() => setIsQuoteModalOpen(false)}
        isDarkMode={isDarkMode}
        preSelectedService={preSelectedService}  
      />
    </div>
  );
}